<div mat-dialog-content>
  <h1 mat-dialog-title>Download your data from Facebook</h1>
  <button class="close-button" mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <div>
    <ul>
      <li>Download your Facebook archive from the link below</li>
    </ul>
    <div class="input-container">
      <a mat-raised-button color="primary" href="https://www.facebook.com/dyi/" target="_blank">
        <mat-icon>link</mat-icon>
        Download your data
      </a>
    </div>
    <ul>
      <li>Select media quality <b>"Low"</b></li>
      <li>Select format <b>"JSON"</b></li>
      <li>Click <b>"Deselect all"</b></li>
      <li>Select <b>"Messages"</b></li>
      <li>Click <b>"Create file"</b> and wait for an email saying your file is ready to download (around 10 minutes)</li>
      <li>Download the zip file, unzip it, and save it somewhere on your computer</li>
    </ul>
  </div>
</div>
